import React from "react";
import Popup from "reactjs-popup";
import moment from "moment";

import { Link } from "react-router-dom";

function App({ events }) {
  const canEditEvent = () => {
    if (
      localStorage.getItem("role") === "Treinador" ||
      localStorage.getItem("role") === "Clube"
    ) {
      return true;
    }

    return false;
  };

  return (
    <table className="table is-fullwidth">
      <thead>
        <tr>
          <th>
            Próximos Eventos
          </th>
          {localStorage.getItem("role") === "Clube" && (
            <th>
              Escalão
            </th>
          )}
          <th>
            Data
          </th>
          <th>
            Local
          </th>
          <th>
            Ações
          </th>
        </tr>
      </thead>
      <tbody>
        {events &&
          events.length > 0 &&
          events.map((el, idx) => (
            <tr key={idx}>
              <td>{el.attributes.type}</td>
              {localStorage.getItem("role") === "Clube" && (
                <td>
                  {el?.attributes?.team?.data?.attributes?.level ? el.attributes.team.data.attributes.level : '' }
                </td>
              )}
              <td>
                {el.attributes.when
                  ? moment(el.attributes.when).format("DD-MM-YYYY - HH:mm")
                  : ""}
              </td>
              <td>{el.attributes.where}</td>
              <td>
                {" "}
                <Popup
                  trigger={<i className="fa fa-ellipsis-v"></i>}
                  position="left center"
                >
                  <div className="dropdown-content">
                    <Link
                      className="dropdown-item"
                      to={
                        el.attributes.type.startsWith('vs')
                          ? `/jogos/${el.id}`
                          : `/eventos/${el.id}`
                      }
                    >
                      Detalhe
                    </Link>
                    {canEditEvent() && (
                      <Link
                        className="dropdown-item"
                        to={
                          el.attributes.type.startsWith('vs')
                            ? `/jogos/${el.id}/apagar`
                            : `/eventos/${el.id}/apagar`
                        }
                      >
                        Remover Evento
                      </Link>
                    )}
                  </div>
                </Popup>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default App;
